import axios from './axios';
import config from '../../helpers/config';

export default (svocId, designGuid, designName) => {
  const url = config.designBuilderBrokerSaveDesignPath;
  const payload = {
    svocId,
    designGuid,
    designName,
    configuratorCode: 'AB',
  };

  return axios.post(url, payload);
};
